

import { api, tempApi } from './api';
import { businessAuthService } from './businessAuth';
import { setToken } from '../utils/auth';

export const authService = {
  // Admin login (regular token)
  login: async (email, password) => {
    console.log('📞 [AUTH] Making admin login request...');
    console.log('📧 Email:', email);
    
    try {
      const response = await tempApi.post('/api/auth/login', {
        email,
        password,
      });

      console.log('✅ [AUTH] Admin login response received');
      console.log('📋 Full response:', JSON.stringify(response.data, null, 2));
      
      const { token, user } = response.data;
      
      // DEBUG: Log token details
      console.log('🔐 [AUTH] Token from response:', token);
      console.log('📏 [AUTH] Token length:', token?.length);
      console.log('🔍 [AUTH] Token type:', typeof token);
      console.log('👤 [AUTH] User from response:', user);

      if (!token) {
        console.error('❌ [AUTH] NO TOKEN in admin login response!');
        throw new Error('No authentication token received from server');
      }
      
      if (typeof token !== 'string') {
        console.error('❌ [AUTH] Token is not a string:', typeof token);
        throw new Error(`Invalid token type: ${typeof token}`);
      }
      
      if (token === 'undefined') {
        console.error('❌ [AUTH] Token is literal string "undefined"');
        throw new Error('Server returned invalid token');
      }
      setToken(token, 'admin');
      return { success: true, user: { ...user, token } };
    } catch (error) {
      console.error('❌ [AUTH] Admin login API error:', error);
      console.error('📡 Error response:', error.response?.data);
      return {
        success: false,
        error: error.response?.data?.message || error.message || 'Login failed',
      };
    }
  },

  // Business login (may return temp token)
  // Business login (may return temp token)
businessLogin: async (username, password) => {
  console.log('📞 [AUTH] Calling businessAuthService.businessLogin...');
  
  const result = await businessAuthService.businessLogin(username, password);
  
  if (result.success) {
    console.log('✅ [AUTH] Business login service returned success');
    console.log('🔐 Token exists:', !!result.token);
    console.log('📏 Token length:', result.token?.length);
    console.log('🔄 Requires password change:', result.requiresPasswordChange);
    
    // FIX: If user is undefined but business exists, create user
    if (!result.user && result.business) {
      result.user = {
        id: result.business.id,
        businessId: result.business.businessId,
        businessName: result.business.businessName,
        username: result.business.username,
        email: result.business.email,
        role: 'business'
      };
    }
  } else {
    console.error('❌ [AUTH] Business login service failed:', result.error);
  }
  
  return result;
},

  // Common logout
  // logout: () => {
  //   console.log('🧹 [AUTH] Clearing localStorage...');
  //   localStorage.clear();
  // },
  logout: () => {
  console.log('🧹 [AUTH] Clearing localStorage...');
  localStorage.removeItem('token_admin');
  localStorage.removeItem('token_business');
  localStorage.removeItem('active_role');
  localStorage.removeItem('authType');
  localStorage.removeItem('industry');
},
};